export default "__VITE_ASSET__aab00b76__"